const rules = require("./rules");

module.exports.rules = rules;



// WEBPACK FOOTER //
// ./common/validations/index.js